import type { HtmlElementWithSrc } from '../types/HtmlElementWithSrc';

/**
 * Get all elements with a src attribute in the given element and its shadow DOM
 */
export const getSrcElements = (elem: ParentNode): HtmlElementWithSrc[] =>
  Array.from(elem.querySelectorAll('*[src]'))
    .flatMap(value =>
      (value.shadowRoot ? getSrcElements(value.shadowRoot) : [value]),
    )
    .filter((element: Element): element is HtmlElementWithSrc =>
      element.hasAttribute('src'),
    );
